import { SystemField } from "./system-field";

export class PurchaseOrderDetailModel extends SystemField { 
     product_id?:string;
     qty?:number;
     cost?:number;
     discount_rate?:number;
     purchase_orders_id?:string;
     pr_qty?:number;
     uom_id?:string;
     discount_amount?:string;
     langs?:any;
}
export class PurchaseOrderDetailTranslateModel extends SystemField{ 
     po_details_id?:string;
     description?:string;
     lang_code?:string;
}